require('./parameterizedAction.i18n.json');
require('./parameterizedAction.tpl.html');
require('./parameterizedActionController.js');

const ParameterizedActionComponent = {
    templateUrl: '/common/rule/ruleAction/parameterizedAction/parameterizedAction.tpl.html',
    controller: 'parameterizedActionController',
    bindings: {
        parameter: '<',
        displayExpression:'<',
        canUserManageFormRules: '<'
    }
};

angular.module('umCore')
    .component('uiParameterizedAction', ParameterizedActionComponent);
